export function getCountries() {
  return [{ _id: "Angola", name: "Angola" }, { _id: "United States", name: "United States" }];
}
export function getProvinces(country){
  const countries = {
    "Angola": [
      { _id: "Bengo", name: "Bengo" },
      { _id: "Benguela", name: "Benguela" },
      { _id: "Bié", name: "Bié" },
      { _id: "Cabinda", name: "Cabinda" },
      { _id: "Cuando-Cubango", name: "Cuando-Cubango" },
      { _id: "Cuanza Norte", name: "Cuanza Norte" },
      { _id: "Cuanza Sul", name: "Cuanza Sul" },
      { _id: "Cunene", name: "Cunene" },
      { _id: "Huambo", name: "Huambo" },
      { _id: "Huíla", name: "Huíla" },
      { _id: "Luanda", name: "Luanda" },
      { _id: "Lunda Norte", name: "Lunda Norte" },
      { _id: "Lunda Sul", name: "Lunda Sul" },
      { _id: "Malanje", name: "Malanje" },
      { _id: "Moxico", name: "Moxico" },
      { _id: "Namibe", name: "Namibe" },
      { _id: "Uíge", name: "Uíge" },
      { _id: "Zaire", name: "Zaire" },
    ],
    "United States": [
      { _id: "Alabama", name: "Alabama" },
      { _id: "Alaska", name: "Alaska" },
      { _id: "American Samoa", name: "American Samoa" },
      { _id: "Arizona", name: "Arizona" },
      { _id: "Arkansas", name: "Arkansas" },
      { _id: "California", name: "California" },
      { _id: "Colorado", name: "Colorado" },
      { _id: "Connecticut", name: "Connecticut" },
      { _id: "Delaware", name: "Delaware" },
      { _id: "Florida", name: "Florida" },
      { _id: "Georgia", name: "Georgia" },
      { _id: "Guam", name: "Guam" },
      { _id: "Hawaii", name: "Hawaii" },
      { _id: "Idaho", name: "Idaho" },
      { _id: "Illinois", name: "Illinois" },
      { _id: "Indiana", name: "Indiana" },
      { _id: "Iowa", name: "Iowa" },
      { _id: "Kansas", name: "Kansas" },
      { _id: "Kentucky", name: "Kentucky" },
      { _id: "Louisiana", name: "Louisiana" },
      { _id: "Maine", name: "Maine" },
      { _id: "Maryland", name: "Maryland" },
      { _id: "Massachusetts", name: "Massachusetts" },
      { _id: "Michigan", name: "Michigan" },
      { _id: "Minnesota", name: "Minnesota" },
      { _id: "Mississippi", name: "Mississippi" },
      { _id: "Missouri", name: "Missouri" },
      { _id: "Montana", name: "Montana" },
      { _id: "Nebraska", name: "Nebraska" },
      { _id: "Nevada", name: "Nevada" },
      { _id: "New Hampshire", name: "New Hampshire" },
      { _id: "New Jersey", name: "New Jersey" },
      { _id: "New Mexico", name: "New Mexico" },
      { _id: "New York", name: "New York" },
      { _id: "North Carolina", name: "North Carolina" },
      { _id: "North Dakota", name: "North Dakota" },
      { _id: "Northern Mariana Islands", name: "Northern Mariana Islands" },
      { _id: "Ohio", name: "Ohio" },
      { _id: "Oklahoma", name: "Oklahoma" },
      { _id: "Oregon", name: "Oregon" },
      { _id: "Pennsylvania", name: "Pennsylvania" },
      { _id: "Puerto Rico", name: "Puerto Rico" },
      { _id: "Rhode Island", name: "Rhode Island" },
      { _id: "South Carolina", name: "South Carolina" },
      { _id: "South Dakota", name: "South Dakota" },
      { _id: "Tennessee", name: "Tennessee" },
      { _id: "Texas", name: "Texas" },
      { _id: "Utah", name: "Utah" },
      { _id: "U.S. Virgin Islands", name: "U.S. Virgin Islands" },
      { _id: "Vermont", name: "Vermont" },
      { _id: "Virginia", name: "Virginia" },
      { _id: "Washington", name: "Washington" },
      { _id: "West Virginia", name: "West Virginia" },
      { _id: "Wisconsin", name: "Wisconsin" },
      { _id: "Wyoming", name: "Wyoming" },
    ],
  }

  if (!countries[country]) return [];
  else return countries[country];
}
